import eotwJSXFactory from "base/eotwJSXFactory";
import handleNavigation from "navigation";

$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }

    handleNavigation();
});

window.eotwJSXFactory = eotwJSXFactory;